<div class="teams-wrapper">
  <app-team-list></app-team-list>
</div>